import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import * as actions from '../../../actions'
import { Container, CardGroup, Card, Loader } from 'semantic-ui-react'

const Games = ({ gameClicked }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [innerWidth, setInnerWidth] = useState(window.innerWidth)
    const dispatch = useDispatch()
    const user = useSelector(state => state.userReseller)
    const games = useSelector(state => state.games)

    useEffect(() => {
        if (!games) setIsLoading(true)
    }, [games])

    useEffect(() => {
        dispatch(actions.fetchGames('resellers'))
        const handleResize = () => setInnerWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [dispatch])

    useEffect(() => {
        if (!!games) setIsLoading(false)
    }, [games])

    const renderCards = () => {
        const rows = []
        let height = '11rem'
        // let height = '43rem'
        // if (innerWidth < 1200) height = '32.5rem'
        // if (innerWidth < 992) height = '25rem'
        // if (innerWidth < 700) height = '23rem'
        // if (innerWidth < 630) height = '21rem'
        // if (innerWidth < 575) height = '19rem'
        // if (innerWidth < 523) height = '17rem'
        // if (innerWidth < 500) height = '16rem'
        // if (innerWidth < 480) height = '15rem'
        // if (innerWidth < 450) height = '14rem'
        // if (innerWidth < 400) height = '12.5rem'
        // if (innerWidth < 350) height = '11rem'
        
        for (const [i, game] of (games || []).entries()) {
            if (user.email === 'emperor@egcglobal.com' || user.email === 'ana') {

            } else {
                if (game.isHidden) continue   
            }
            rows.push(
                <Card onClick={() => gameClicked(game)} key={i} link raised stackable doubling image={{ src: game.gameImage, style: { backgroundColor: '#2a2b2c', height, width: '100%', objectFit: 'fill' } }} 
                        header={{ content: game.name, style: { color: 'white' } }} description={{ content: game.tagline, style: { color: 'white' } }} style={{ backgroundColor: '#2a2b2c' }} inverted/>
            )
        }
        return <CardGroup inverted style={{ marginTop: 20, marginBottom: 50, background: '#1b1c1d' }} centered doubling itemsPerRow={4}>{rows}</CardGroup>
    }

    if (isLoading) return(<Loader active/>)

    return (
        <Container inverted style={{ background: '#1b1c1d', minHeight: '100vh'}}>
            <h1 style={{ marginTop: 30, color: 'white' }}>Games</h1>
            {renderCards()}
        </Container>
    )
}

export default Games